import Alpine from 'alpinejs';
import { familySelect } from './familySelect';
import { registerFaqFilter } from './faqs';
// import { anotherComp } from './components/anotherComp'; // 계속 추가

let started = false;

export function registerAlpineComponents() {
  document.addEventListener('alpine:init', () => {
    familySelect(Alpine);
    registerFaqFilter(Alpine);
    // anotherComp(Alpine);
    // ...여기서만 Alpine.data 등록을 관리
  });
}

export function startAlpineOnce() {
  if (started) return;
  window.Alpine = Alpine;
  Alpine.start(); // 앱 부팅은 1회만
  started = true;
}

export function initAlpineTree(scopeEl = document) {
  // SPA/Barba처럼 부분적으로 DOM이 바뀔 때 사용
  Alpine.initTree(scopeEl);
}
